export default __webpack_public_path__ + "static/media/jaguar2.c5d44f31.png";